import React from 'react';
import PropTypes from 'prop-types';

import { SkipNavigationButton } from './SkipNavigation.styles';

const SkipNavigation = ({ intl: { formatMessage } }) => (
  <SkipNavigationButton href="#content" variant="secondary" size="small">
    {formatMessage({ id: 'HEADER_SKIP_NAVIGATION' })}
  </SkipNavigationButton>
);

SkipNavigation.propTypes = {
  intl: PropTypes.object.isRequired,
};

export { SkipNavigation };
